import { render, staticRenderFns } from "./AuthPassword.vue?vue&type=template&id=56b6fe64"
import script from "./AuthPassword.vue?vue&type=script&lang=js"
export * from "./AuthPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports